export default __webpack_public_path__ + "static/media/Folder_icon.7191787c.svg";